import { ApiBackendClient } from "./api_backend_helper";
import { ApiAuthClient } from "./api_auth_helper";

import * as url from "./url_helper";

const apiBackendClient = new ApiBackendClient();
const apiAuthClient = new ApiAuthClient();

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

// //is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
export const postFakeRegister = data => apiBackendClient.create(url.POST_FAKE_REGISTER, data);

// Login Method
export const postFakeLogin = data => apiBackendClient.create(url.POST_FAKE_LOGIN, data);

// postForgetPwd
export const postFakeForgetPwd = data => apiBackendClient.create(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
export const postJwtProfile = data => apiBackendClient.create(url.POST_EDIT_JWT_PROFILE, data);

export const postFakeProfile = (data) => apiBackendClient.update(url.POST_EDIT_PROFILE + '/' + data.idx, data);

// Register Method
export const postJwtRegister = (url, data) => {
  return apiBackendClient.create(url, data)
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message = "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method
export const postJwtLogin = data => apiBackendClient.create(url.POST_FAKE_JWT_LOGIN, data);

// postForgetPwd
export const postJwtForgetPwd = data => apiBackendClient.create(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = data => apiBackendClient.create(url.SOCIAL_LOGIN, data);

// Calendar
// get Events
export const getEvents = () => apiBackendClient.get(url.GET_EVENTS);

// get Events
export const getCategories = () => apiBackendClient.get(url.GET_CATEGORIES);

// get Upcomming Events
export const getUpCommingEvent = () => apiBackendClient.get(url.GET_UPCOMMINGEVENT);

// add Events
export const addNewEvent = event => apiBackendClient.create(url.ADD_NEW_EVENT, event);

// update Event
export const updateEvent = event => apiBackendClient.put(url.UPDATE_EVENT, event);

// delete Event
export const deleteEvent = event => apiBackendClient.delete(url.DELETE_EVENT, { headers: { event } });

// Chat
// get Contact
export const getDirectContact = () => apiBackendClient.get(url.GET_DIRECT_CONTACT);

// get Messages
export const getMessages = roomId => apiBackendClient.get(`${url.GET_MESSAGES}/${roomId}`, { params: { roomId } });

// add Message
export const addMessage = message => apiBackendClient.create(url.ADD_MESSAGE, message);

// add Message
export const deleteMessage = message => apiBackendClient.delete(url.DELETE_MESSAGE, { headers: { message } });

// get Channels
export const getChannels = () => apiBackendClient.get(url.GET_CHANNELS);

// MailBox
//get Mail
export const getMailDetails = () => apiBackendClient.get(url.GET_MAIL_DETAILS);

// delete Mail
export const deleteMail = forId => apiBackendClient.delete(url.DELETE_MAIL, { headers: { forId } });

// Ecommerce
// get Products
export const getProducts = () => apiBackendClient.get(url.GET_PRODUCTS);

// delete Product
export const deleteProducts = product => apiBackendClient.delete(url.DELETE_PRODUCT + '/' + product);

// add Products
export const addNewProduct = product => apiBackendClient.create(url.ADD_NEW_PRODUCT, product);

// update Products
export const updateProduct = product => apiBackendClient.update(url.UPDATE_PRODUCT + '/' + product._id, product);

// get Orders
export const getOrders = () => apiBackendClient.get(url.GET_ORDERS);

// add Order
export const addNewOrder = order => apiBackendClient.create(url.ADD_NEW_ORDER, order);

// update Order
export const updateOrder = order => apiBackendClient.update(url.UPDATE_ORDER + '/' + order._id, order);

// delete Order
export const deleteOrder = order => apiBackendClient.delete(url.DELETE_ORDER + '/' + order);

// get Customers
export const getCustomers = () => apiBackendClient.get(url.GET_CUSTOMERS);

// add Customers
export const addNewCustomer = customer => apiBackendClient.create(url.ADD_NEW_CUSTOMER, customer);

// update Customers
export const updateCustomer = customer => apiBackendClient.update(url.UPDATE_CUSTOMER + '/' + customer._id, customer);

// delete Customers
export const deleteCustomer = customer => apiBackendClient.delete(url.DELETE_CUSTOMER + '/' + customer);

// get Sellers
export const getSellers = () => apiBackendClient.get(url.GET_SELLERS);

// Project
// get Project list 
export const getProjectList = () => apiBackendClient.get(url.GET_PROJECT_LIST);

// Tasks
// get Task
export const getTaskList = () => apiBackendClient.get(url.GET_TASK_LIST);

// add Task
export const addNewTask = task => apiBackendClient.create(url.ADD_NEW_TASK, task);

// update Task
export const updateTask = task => apiBackendClient.update(url.UPDATE_TASK + '/' + task._id, task);

// delete Task
export const deleteTask = task => apiBackendClient.delete(url.DELETE_TASK + '/' + task);

// Kanban Board
export const getTasks = () => apiBackendClient.get(url.GET_TASKS);
export const addNewTasks = (card) => apiBackendClient.create(url.ADD_TASKS, card)
export const updateTasks = (card) => apiBackendClient.put(url.UPDATE_TASKS, card)
export const deleteTasks = (card) => apiBackendClient.delete(url.DELETE_TASKS, { headers: { card } })

// CRM
// get Contacts
export const getContacts = () => apiBackendClient.get(url.GET_CONTACTS);

// add Contact
export const addNewContact = contact => apiBackendClient.create(url.ADD_NEW_CONTACT, contact);

// update Contact
export const updateContact = contact => apiBackendClient.update(url.UPDATE_CONTACT + '/' + contact._id, contact);

// delete Contact
export const deleteContact = contact => apiBackendClient.delete(url.DELETE_CONTACT + '/' + contact);

// get Companies
export const getCompanies = () => apiBackendClient.get(url.GET_COMPANIES);

// add Companies
export const addNewCompanies = company => apiBackendClient.create(url.ADD_NEW_COMPANIES, company);

// update Companies
export const updateCompanies = company => apiBackendClient.update(url.UPDATE_COMPANIES + '/' + company._id, company);

// delete Companies
export const deleteCompanies = company => apiBackendClient.delete(url.DELETE_COMPANIES + '/' + company);

// get Deals
export const getDeals = () => apiBackendClient.get(url.GET_DEALS);

// get Leads
export const getLeads = () => apiBackendClient.get(url.GET_LEADS);

// add Lead
export const addNewLead = lead => apiBackendClient.create(url.ADD_NEW_LEAD, lead);

// update Lead
export const updateLead = lead => apiBackendClient.update(url.UPDATE_LEAD + '/' + lead._id, lead);

// delete Lead
export const deleteLead = lead => apiBackendClient.delete(url.DELETE_LEAD + '/' + lead);

// Crypto
// Transation
export const getTransationList = () => apiBackendClient.get(url.GET_TRANSACTION_LIST);

// Order List
export const getOrderList = () => apiBackendClient.get(url.GET_ORDRER_LIST);

// Invoice
//get Invoice
export const getInvoices = () => apiBackendClient.get(url.GET_INVOICES);

// add Invoice
export const addNewInvoice = invoice => apiBackendClient.create(url.ADD_NEW_INVOICE, invoice);

// update Invoice
export const updateInvoice = invoice => apiBackendClient.update(url.UPDATE_INVOICE + '/' + invoice._id, invoice);

// delete Invoice
export const deleteInvoice = invoice => apiBackendClient.delete(url.DELETE_INVOICE + '/' + invoice);

// Support Tickets 
// Tickets
export const getTicketsList = () => apiBackendClient.get(url.GET_TICKETS_LIST);

// add Tickets 
export const addNewTicket = ticket => apiBackendClient.create(url.ADD_NEW_TICKET, ticket);

// update Tickets 
export const updateTicket = ticket => apiBackendClient.update(url.UPDATE_TICKET + '/' + ticket._id, ticket);

// delete Tickets 
export const deleteTicket = ticket => apiBackendClient.delete(url.DELETE_TICKET + '/' + ticket);

// Dashboard Analytics

// Sessions by Countries
export const getAllData = () => apiBackendClient.get(url.GET_ALL_DATA);
export const getHalfYearlyData = () => apiBackendClient.get(url.GET_HALFYEARLY_DATA);
export const getMonthlyData = () => apiBackendClient.get(url.GET_MONTHLY_DATA);

// Audiences Metrics
export const getAllAudiencesMetricsData = () => apiBackendClient.get(url.GET_ALLAUDIENCESMETRICS_DATA);
export const getMonthlyAudiencesMetricsData = () => apiBackendClient.get(url.GET_MONTHLYAUDIENCESMETRICS_DATA);
export const getHalfYearlyAudiencesMetricsData = () => apiBackendClient.get(url.GET_HALFYEARLYAUDIENCESMETRICS_DATA);
export const getYearlyAudiencesMetricsData = () => apiBackendClient.get(url.GET_YEARLYAUDIENCESMETRICS_DATA);

// Users by Device
export const getTodayDeviceData = () => apiBackendClient.get(url.GET_TODAYDEVICE_DATA);
export const getLastWeekDeviceData = () => apiBackendClient.get(url.GET_LASTWEEKDEVICE_DATA);
export const getLastMonthDeviceData = () => apiBackendClient.get(url.GET_LASTMONTHDEVICE_DATA);
export const getCurrentYearDeviceData = () => apiBackendClient.get(url.GET_CURRENTYEARDEVICE_DATA);

// Audiences Sessions by Country
export const getTodaySessionData = () => apiBackendClient.get(url.GET_TODAYSESSION_DATA);
export const getLastWeekSessionData = () => apiBackendClient.get(url.GET_LASTWEEKSESSION_DATA);
export const getLastMonthSessionData = () => apiBackendClient.get(url.GET_LASTMONTHSESSION_DATA);
export const getCurrentYearSessionData = () => apiBackendClient.get(url.GET_CURRENTYEARSESSION_DATA);

// Dashboard CRM

// Balance Overview
export const getTodayBalanceData = () => apiBackendClient.get(url.GET_TODAYBALANCE_DATA);
export const getLastWeekBalanceData = () => apiBackendClient.get(url.GET_LASTWEEKBALANCE_DATA);
export const getLastMonthBalanceData = () => apiBackendClient.get(url.GET_LASTMONTHBALANCE_DATA);
export const getCurrentYearBalanceData = () => apiBackendClient.get(url.GET_CURRENTYEARBALANCE_DATA);

// Dial Type
export const getTodayDealData = () => apiBackendClient.get(url.GET_TODAYDEAL_DATA);
export const getWeeklyDealData = () => apiBackendClient.get(url.GET_WEEKLYDEAL_DATA);
export const getMonthlyDealData = () => apiBackendClient.get(url.GET_MONTHLYDEAL_DATA);
export const getYearlyDealData = () => apiBackendClient.get(url.GET_YEARLYDEAL_DATA);

// Sales Forecast
export const getOctSalesData = () => apiBackendClient.get(url.GET_OCTSALES_DATA);
export const getNovSalesData = () => apiBackendClient.get(url.GET_NOVSALES_DATA);
export const getDecSalesData = () => apiBackendClient.get(url.GET_DECSALES_DATA);
export const getJanSalesData = () => apiBackendClient.get(url.GET_JANSALES_DATA);

// Dashboard Ecommerce
// Revenue
export const getAllRevenueData = () => apiBackendClient.get(url.GET_ALLREVENUE_DATA);
export const getMonthRevenueData = () => apiBackendClient.get(url.GET_MONTHREVENUE_DATA);
export const getHalfYearRevenueData = () => apiBackendClient.get(url.GET_HALFYEARREVENUE_DATA);
export const getYearRevenueData = () => apiBackendClient.get(url.GET_YEARREVENUE_DATA);


// Dashboard Crypto
// Portfolio
export const getBtcPortfolioData = () => apiBackendClient.get(url.GET_BTCPORTFOLIO_DATA);
export const getUsdPortfolioData = () => apiBackendClient.get(url.GET_USDPORTFOLIO_DATA);
export const getEuroPortfolioData = () => apiBackendClient.get(url.GET_EUROPORTFOLIO_DATA);

// Market Graph
export const getAllMarketData = () => apiBackendClient.get(url.GET_ALLMARKETDATA_DATA);
export const getYearMarketData = () => apiBackendClient.get(url.GET_YEARMARKET_DATA);
export const getMonthMarketData = () => apiBackendClient.get(url.GET_MONTHMARKET_DATA);
export const getWeekMarketData = () => apiBackendClient.get(url.GET_WEEKMARKET_DATA);
export const getHourMarketData = () => apiBackendClient.get(url.GET_HOURMARKET_DATA);

// Dashboard Project
// Project Overview
export const getAllProjectData = () => apiBackendClient.get(url.GET_ALLPROJECT_DATA);
export const getMonthProjectData = () => apiBackendClient.get(url.GET_MONTHPROJECT_DATA);
export const gethalfYearProjectData = () => apiBackendClient.get(url.GET_HALFYEARPROJECT_DATA);
export const getYearProjectData = () => apiBackendClient.get(url.GET_YEARPROJECT_DATA);

// Project Status
export const getAllProjectStatusData = () => apiBackendClient.get(url.GET_ALLPROJECTSTATUS_DATA);
export const getWeekProjectStatusData = () => apiBackendClient.get(url.GET_WEEKPROJECTSTATUS_DATA);
export const getMonthProjectStatusData = () => apiBackendClient.get(url.GET_MONTHPROJECTSTATUS_DATA);
export const getQuarterProjectStatusData = () => apiBackendClient.get(url.GET_QUARTERPROJECTSTATUS_DATA);

// Dashboard NFT
// Marketplace
export const getAllMarketplaceData = () => apiBackendClient.get(url.GET_ALLMARKETPLACE_DATA);
export const getMonthMarketplaceData = () => apiBackendClient.get(url.GET_MONTHMARKETPLACE_DATA);
export const gethalfYearMarketplaceData = () => apiBackendClient.get(url.GET_HALFYEARMARKETPLACE_DATA);
export const getYearMarketplaceData = () => apiBackendClient.get(url.GET_YEARMARKETPLACE_DATA);

// Project
export const addProjectList = (project) => apiBackendClient.create(url.ADD_NEW_PROJECT, project);
export const updateProjectList = (project) => apiBackendClient.put(url.UPDATE_PROJECT, project);
export const deleteProjectList = (project) => apiBackendClient.delete(url.DELETE_PROJECT, { headers: { project } });

// Pages > Team
export const getTeamData = (team) => apiBackendClient.get(url.GET_TEAMDATA, team);
export const deleteTeamData = (team) => apiBackendClient.delete(url.DELETE_TEAMDATA, { headers: { team } });
export const addTeamData = (team) => apiBackendClient.create(url.ADD_NEW_TEAMDATA, team);
export const updateTeamData = (team) => apiBackendClient.put(url.UPDATE_TEAMDATA, team);

// File Manager

// Folder
export const getFolders = (folder) => apiBackendClient.get(url.GET_FOLDERS, folder);
export const deleteFolder = (folder) => apiBackendClient.delete(url.DELETE_FOLDER, { headers: { folder } });
export const addNewFolder = (folder) => apiBackendClient.create(url.ADD_NEW_FOLDER, folder);
export const updateFolder = (folder) => apiBackendClient.put(url.UPDATE_FOLDER, folder);

// File
export const getFiles = (file) => apiBackendClient.get(url.GET_FILES, file);
export const deleteFile = (file) => apiBackendClient.delete(url.DELETE_FILE, { headers: { file } });
export const addNewFile = (file) => apiBackendClient.create(url.ADD_NEW_FILE, file);
export const updateFile = (file) => apiBackendClient.put(url.UPDATE_FILE, file);

// To Do
export const getTodos = (todo) => apiBackendClient.get(url.GET_TODOS, todo);
export const deleteTodo = (todo) => apiBackendClient.delete(url.DELETE_TODO, { headers: { todo } });
export const addNewTodo = (todo) => apiBackendClient.create(url.ADD_NEW_TODO, todo);
export const updateTodo = (todo) => apiBackendClient.put(url.UPDATE_TODO, todo);

// To do Project
export const getProjects = (project) => apiBackendClient.get(url.GET_PROJECTS, project);
export const addNewProject = (project) => apiBackendClient.create(url.ADD_NEW_TODO_PROJECT, project);

//Job Application
export const getJobApplicationList = () => apiBackendClient.get(url.GET_APPLICATION_LIST);

//API Key
export const getAPIKey = () => apiBackendClient.get(url.GET_API_KEY);

//Get application logo
export const getApplicationLogo = (params) => apiAuthClient.get(url.GET_LOGO, params);

//get token
export const getToken = (params) => apiAuthClient.get(url.GET_TOKEN, params);

//get userInfo
export const getUserInfo = (params) => apiAuthClient.get(url.GET_USER_INFO, params);

//get legacyEmpresas
export const getLegacyEmpresas = (params) => apiBackendClient.get(url.GET_LEGACY_EMPRESAS, params);

//get legacyDepartamentos
export const getLegacyDepartamentos = (params) => apiBackendClient.get(url.GET_LEGACY_DEPARTAMENTOS, params);

//get legacyCitas
export const getLegacyCitas = (params) => apiBackendClient.get(url.GET_LEGACY_CITAS, params);


export const getLegacyRecepcionesVehiculos = (params) => apiBackendClient.get(url.RECEPCION_VEHICULO_POR_FECHA, params);

export const getLegacyRecepcionVehiculoPorId = (params) => apiBackendClient.get(url.RECEPCION_VEHICULO_POR_ID, params);

//post legacyRecepcionesVehiculos
export const createLegacyRecepcionVehiculo = (data) => apiBackendClient.create(url.RECEPCION_VEHICULO_CREAR, data);


// getVehiculoPorPatente
export const getVehiculoPorPatente = (params) => apiBackendClient.get(`${url.GET_ST_VEHICU}/${params.empresa}/${params.patente}`, params);

// getVehiculosPorTenant
export const getVehiculosPorTenant = (params) => apiBackendClient.get(url.GET_ST_VEHICU, params);

//get legacyPatentes
export const getLegacyPatentes = (params) => apiBackendClient.get(url.GET_LEGACY_PATENTES, params);

//get legacyPersonas
export const getLegacyPersonas = (params) => apiBackendClient.get(url.GET_LEGACY_PERSONAS, params);

//get legacyMarcas
export const getLegacyMarcas = (params) => apiBackendClient.get(url.GET_LEGACY_MARCAS, params);

//get legacyModelos
export const getLegacyModelos = (params) => apiBackendClient.get(url.GET_LEGACY_MODELOS, params);

//get legacyColores
export const getLegacyColores = (params) => apiBackendClient.get(url.GET_LEGACY_COLORES, params);

//get legacyTiposTraccion
export const getLegacyTiposTraccion = (params) => apiBackendClient.get(url.GET_LEGACY_TIPOS_TRACCION, params);

//get legacyTiposTransmision
export const getLegacyTiposTransmision = (params) => apiBackendClient.get(url.GET_LEGACY_TIPOS_TRANSMISION, params);

//get legacyTiposCombustible
export const getLegacyTiposCombustible = (params) => apiBackendClient.get(url.GET_LEGACY_TIPOS_COMBUSTIBLE, params);

//get legacyTiposTrabajoOt
export const getLegacyTiposTrabajoOt = (params) => apiBackendClient.get(url.GET_LEGACY_TIPOS_TRABAJO_OT, params);

//get legacyRegiones
export const getLegacyRegiones = (params) => apiBackendClient.get(url.GET_LEGACY_REGIONES, params);

//get legacyCiudades
export const getLegacyCiudades = (params) => apiBackendClient.get(url.GET_LEGACY_CIUDADES, params);

//get legacyTiposCombustible
export const getLegacyComunas = (params) => apiBackendClient.get(url.GET_LEGACY_COMUNAS, params);

//get contabilidad documentos pendientes
export const getContabilidadDocumentosPendientes = (params) => apiBackendClient.get(url.GET_CONTABILIDAD_DOCUMENTOS_PENDIENTES, params);

// Clientes

export const getClientes = (params) => apiBackendClient.get(url.GET_SG_MAERUT, params);

export const createCliente = (data) => apiBackendClient.create(url.GET_SG_MAERUT, data);

export const updateCliente = (id, data) => apiBackendClient.put(`${url.GET_SG_MAERUT}/${id}`, data);

export const getClienteById = (id, params) => apiBackendClient.get(`${url.GET_SG_MAERUT}/${id}`, params);

// Notifications
export const getNotifications = (params) => apiBackendClient.get(url.GET_NOTIFICATIONS, params);
export const getNotificationById = (id, params) => apiBackendClient.get(`${url.GET_NOTIFICATIONS}/${id}`, params);
export const approveNotification = (id, data) => apiBackendClient.put(`${url.APPROVE_NOTIFICATION.replace(':id', id)}`, data);
export const sendNotification = (id, data) => apiBackendClient.post(`${url.SEND_NOTIFICATION.replace(':id', id)}`, data);

// Rendiciones Fondos
export const getRendicionesFondos = (params) => apiBackendClient.get(url.GET_RENDICIONES_FONDOS, params);
export const getRendicionFondosById = (tipfol, numfol, params) => apiBackendClient.get(`${url.GET_RENDICIONES_FONDOS}/${tipfol}/${numfol}`, params);
export const createRendicionFondos = (data) => apiBackendClient.create(url.GET_RENDICIONES_FONDOS, data);
export const updateRendicionFondos = (tipfol, numfol, data) => apiBackendClient.put(`${url.GET_RENDICIONES_FONDOS}/${tipfol}/${numfol}`, data);
export const deleteRendicionFondos = (tipfol, numfol) => apiBackendClient.delete(`${url.GET_RENDICIONES_FONDOS}/${tipfol}/${numfol}`);

// External DTE Recibidos
export const getDteRecibidos = (params) => apiBackendClient.get(`${url.GET_EXTERNAL_DTE_RECIBIDOS}/${params.rut}/${params.fechaDesde}/${params.fechaHasta}`, params);

// CO_MAEDCV
export const getCoMaedcvPorTenant = (params) => apiBackendClient.get(`${url.GET_CO_MAEDCV}/${params.empresa}`, params);
export const getCoMaedcvById = (claemp, tipfol, numfol, params) => apiBackendClient.get(`${url.GET_CO_MAEDCV}/${claemp}/${tipfol}/${numfol}`, params);
export const createCoMaedcv = (data) => apiBackendClient.create(url.GET_CO_MAEDCV, data);
export const updateCoMaedcv = (claemp, tipfol, numfol, data) => apiBackendClient.put(`${url.GET_CO_MAEDCV}/${claemp}/${tipfol}/${numfol}`, data);
export const deleteCoMaedcv = (claemp, tipfol, numfol) => apiBackendClient.delete(`${url.GET_CO_MAEDCV}/${claemp}/${tipfol}/${numfol}`);

// Plantillas Cobranza
export const getPlantillasCobranza = (params) => apiBackendClient.get(url.GET_PLANTILLAS_COBRANZA, params);
export const getPlantillaCobranzaById = (id) => apiBackendClient.get(`${url.GET_PLANTILLAS_COBRANZA}/${id}`);
export const createPlantillaCobranza = (data) => apiBackendClient.create(url.GET_PLANTILLAS_COBRANZA, data);
export const updatePlantillaCobranza = (id, data) => apiBackendClient.put(`${url.GET_PLANTILLAS_COBRANZA}/${id}`, data);
export const deletePlantillaCobranza = (id, tenantId) => apiBackendClient.delete(`${url.GET_PLANTILLAS_COBRANZA}/${id}?tenantId=${tenantId}`);

// SG_ORDCOM
export const getOrdenesCompra = (params) => apiBackendClient.get(url.GET_SG_ORDCOM, params);
export const getOrdenCompraById = (claemp, nroodc, params) => apiBackendClient.get(`${url.GET_SG_ORDCOM}/${claemp}/${nroodc}`, params);
export const createOrdenCompra = (data) => apiBackendClient.create(url.GET_SG_ORDCOM, data);
export const updateOrdenCompra = (claemp, nroodc, data) => apiBackendClient.put(`${url.GET_SG_ORDCOM}/${claemp}/${nroodc}`, data);
export const deleteOrdenCompra = (claemp, nroodc) => apiBackendClient.delete(`${url.GET_SG_ORDCOM}/${claemp}/${nroodc}`);

// MENU_PERMISSIONS
export const getMenuPermissions = (params) => apiBackendClient.get(url.GET_MENU_PERMISSIONS, params);
export const getMenuPermissionById = (menu_id, role, params) => apiBackendClient.get(`${url.GET_MENU_PERMISSIONS}/${menu_id}/${role}`, params);
export const createMenuPermission = (data) => apiBackendClient.create(url.GET_MENU_PERMISSIONS, data);
export const updateMenuPermission = (menu_id, role, data) => apiBackendClient.put(`${url.GET_MENU_PERMISSIONS}/${menu_id}/${role}`, data);
export const deleteMenuPermission = (menu_id, role, tenantId) => apiBackendClient.delete(`${url.GET_MENU_PERMISSIONS}/${menu_id}/${role}?tenantId=${tenantId}`);

// MENU_ITEMS
export const getMenuItems = (params) => apiBackendClient.get(url.GET_MENU_ITEMS, params);
export const getMenuItemById = (id, params) => apiBackendClient.get(`${url.GET_MENU_ITEMS}/${id}`, params);
export const createMenuItem = (tenantId, data) => apiBackendClient.create(`${url.GET_MENU_ITEMS}?tenantId=${tenantId}`, data);
export const updateMenuItem = (tenantId, id, data) => apiBackendClient.put(`${url.GET_MENU_ITEMS}/${id}?tenantId=${tenantId}`, data);
export const deleteMenuItem = (tenantId, id) => apiBackendClient.delete(`${url.GET_MENU_ITEMS}/${id}?tenantId=${tenantId}`);

// SMTP_CREDENTIALS
export const getSmtpCredentials = (params) => apiBackendClient.get(url.GET_SMTP_CREDENTIALS, params);
export const getSmtpCredentialById = (id, params) => apiBackendClient.get(`${url.GET_SMTP_CREDENTIALS}/${id}`, params);
export const createSmtpCredential = (tenantId, data) => apiBackendClient.create(`${url.GET_SMTP_CREDENTIALS}?tenantId=${tenantId}`, data);
export const updateSmtpCredential = (tenantId, id, data) => apiBackendClient.put(`${url.GET_SMTP_CREDENTIALS}/${id}?tenantId=${tenantId}`, data);
export const deleteSmtpCredential = (tenantId, id) => apiBackendClient.delete(`${url.GET_SMTP_CREDENTIALS}/${id}?tenantId=${tenantId}`);

// getMantencionesByMarcaModelo
export const getMantencionesByMarcaModelo = (params) => apiBackendClient.get(`${url.GET_SG_MODMAR_MANTENCIONES}/${params.marca}/${params.modelo}`, params);